/**
 * View component for /admin/authoring/sponsors/new
 *
 * Creates a new sponsor from a copy of the defaultItem in the sponsor reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { history, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as sponsorActions from '../sponsorActions';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx'; 
import Base from '../../../global/components/BaseComponent.js.jsx';
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import sponsor components
import SponsorForm from '../components/SponsorForm.js.jsx';

class AdminCreateSponsor extends Base {
  constructor(props) {
    super(props);
    this.state = {
      sponsor: { ...this.props.defaultSponsor }
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
      , confirmClearTokenModalOpen: false
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
      , '_generateToken'
      , '_clearToken'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newSponsorState = _.update( this.state.sponsor, e.target.name, function() {
      return e.target.value;
    });
    this.setState({sponsor :newSponsorState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(sponsorActions.sendCreateSponsor(this.state.sponsor)).then((action) => {
      if(action.success) {
        dispatch(sponsorActions.invalidateList());
        history.push(`/admin/sponsors/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  _generateToken() {
    let newSponsor = _.cloneDeep(this.state.sponsor); 
    newSponsor.authToken = Math.floor(Math.random()*16777215).toString(16) + Math.floor(Math.random()*16777215).toString(16);
    this.setState({sponsor: newSponsor}); 
  }

  _clearToken() {
    let newSponsor = _.cloneDeep(this.state.sponsor); 
    newSponsor.authToken = null; 
    this.setState({sponsor: newSponsor, confirmClearTokenModalOpen: false});
  }

  render() {
    const { sponsor } = this.state;
    const isEmpty = (sponsor.name === null || sponsor.name === undefined);
    return (
      <div className="flex">
        <section className="section">
          <div className="yt-container">
            <Breadcrumbs links={this.props.location.state.breadcrumbs}/>
          </div>
          { isEmpty ?
              <h2> Loading...</h2>
            :
              <SponsorForm
                cancelLink="/admin/sponsors"
                clearToken={this._clearToken}
                formTitle="Create Sponsor"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                generateToken={this._generateToken}
                sponsor={sponsor}
                showClearTokenModal={() => this.setState({confirmClearTokenModalOpen: true})}
              />
          }
          <AlertModal
            alertMessage={<div> Are you <em>sure</em> you want to clear this authorization token? This sponsor will no longer be able to send third party invites from their end.</div> }
            alertTitle="Clear authorization token"
            closeAction={() => this.setState({confirmClearTokenModalOpen: false})}
            confirmAction={this._clearToken}
            confirmText="Yes, clear token"
            declineText="Never mind"
            isOpen={this.state.confirmClearTokenModalOpen}
            type="warning"
          />
        </section>
      </div>
    )
  }
}

AdminCreateSponsor.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultSponsor: store.sponsor.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCreateSponsor)
);



// WEBPACK FOOTER //
// modules/sponsor/views/AdminCreateSponsor.js.jsx